import { MappedProject } from "./types/new/project";

export function shuffleArray<T>(array: T[]): T[] {
  const shuffledArray = [...array];
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }
  return shuffledArray;
}

export function getProjectName(project: MappedProject) {
  let name = project.name.trim();
  if (project.city) {
    name += `, ${project.city}`;
  }
  if (project.department) {
    name += ` (${project.department})`;
  }
  return name;
}

export function getProjectLocation(project: MappedProject) {
  let location = "";
  if (project.city) {
    location += `${project.city}`;
  }
  if (project.department) {
    location += `, ${project.department}`;
  }
  return location;
}
